<script setup lang="ts">
import { computed } from 'vue';
import TrackRatingBadge from '@/components/AudioFileIssues/TrackRatingBadge.vue';

/**
 * Table cell for the LiveTrack `rating` column: renders the shared rating tier pill
 * (same styling as the Audio File Issues list and TrackCard) instead of plain text.
 */
const props = defineProps<{
  field: string;
  dataType: string;
  data: Record<string, unknown>;
}>();

const rating = computed(() => {
  const value = props.data[props.field];
  return typeof value === 'string' && value.trim() !== '' ? value : null;
});
</script>

<template>
  <div class="min-w-0">
    <TrackRatingBadge v-if="rating" :rating="rating" size="sm" />
    <span v-else class="text-muted-foreground text-sm">—</span>
  </div>
</template>
